import React, { useEffect, useRef } from 'react';
import { Form, useClassNameMapper } from 'react-bootstrap';
import ComponentHelper from '../../../helpers/ui/ComponentHelper/ComponentHelper';
import type { DatetimeEditor } from '../types';
import localStyles from './DatetimeNativeEditor.module.pcss';

/**
 * Remove the seconds from date time.
 *
 * @param datetime
 */
function datetimeFormatRemoveSeconds(datetime: Date): string {
  /**
   * Fix this properly to handle timezone
   */
  const isoStringWithoutTimezone = `${datetime.getFullYear()}-${String(
    datetime.getMonth() + 1
  ).padStart(2, '0')}-${String(datetime.getDate()).padStart(2, '0')}T${String(
    datetime.getHours()
  ).padStart(2, '0')}:${String(datetime.getMinutes()).padStart(2, '0')}:${String(
    datetime.getSeconds()
  ).padStart(2, '0')}`;

  return isoStringWithoutTimezone;
}

/**
 * Datetime-local input field for mobile.
 *
 * @author Vatsalya Agarwal
 */
const DatetimeNativeEditor: React.FC<React.PropsWithChildren<DatetimeEditor>> = ({
  useTimeSelect = true,
  value,
  className,
  onChange,
  focus,
  focusHandler,
  hasBeenFocused,
  placeholder
}) => {
  const cx = useClassNameMapper(localStyles);
  const datetimeRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (focus && focusHandler && datetimeRef) {
      ComponentHelper.focusHandler(hasBeenFocused, datetimeRef.current, focusHandler);
    }
  }, [focus, focusHandler, datetimeRef, hasBeenFocused]);

  return (
    <div className={cx('lia-datetime-local', className)}>
      <Form.Control
        ref={datetimeRef}
        aria-label={placeholder}
        placeholder={placeholder}
        step="any"
        type={useTimeSelect ? 'datetime-local' : 'date'}
        className={cx('lia-datetime-local-input')}
        value={value && datetimeFormatRemoveSeconds(value as unknown as Date)}
        onChange={event => {
          datetimeRef.current.classList.toggle(
            cx('lia-datetime-selected'),
            event.target.value !== ''
          );
          onChange(event.target.value && new Date(event.target.value));
        }}
      />
    </div>
  );
};

export default DatetimeNativeEditor;
